import { Smartphone, Share, X } from "lucide-react";
import { useInstallPrompt } from "@/lib/installPrompt";

/** Inline install banner for the Ask page (mobile only). `variant="done"` = after a ticket is created. */
export function InstallBanner({ variant = "form" }) {
  const { available, ios, install, dismiss } = useInstallPrompt();
  if (!available) return null;
  const done = variant === "done";
  return (
    <div className={`md:hidden relative rounded-2xl border border-[#FFD600]/40 bg-[#FFD600]/5 p-4 text-left ${done ? "mt-6" : "mt-8"}`} data-testid={`ask-install-banner-${variant}`}>
      <button type="button" onClick={dismiss} className="absolute top-1 right-1 w-10 h-10 grid place-items-center text-slate-400" aria-label="Dismiss" data-testid="ask-install-dismiss"><X className="w-4 h-4" /></button>
      <div className="flex items-start gap-3 pr-8">
        <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
        <div className="text-sm">
          <div className="font-display font-semibold text-white">{done ? "Check on your ticket from your home screen" : "Keep Dr.Gadget one tap away"}</div>
          {ios
            ? <p className="text-slate-400 mt-1" data-testid="ask-install-ios-steps">Tap <Share className="inline w-3.5 h-3.5 -mt-0.5 text-cyan-300" /> <strong className="text-slate-200">Share</strong>, then <strong className="text-slate-200">Add to Home Screen</strong>{done ? " — David's replies are one tap away." : " — ask, book or text David without hunting for the site."}</p>
            : <p className="text-slate-400 mt-1">{done ? "Add the app icon so David's replies are one tap away." : "Add the app icon — ask, book or text David without hunting for the site."}</p>}
          {!ios && (
            <button type="button" onClick={install} className="dg-btn-primary rounded-full px-4 py-2.5 min-h-[44px] text-sm mt-3 inline-flex items-center gap-2" data-testid="ask-install-btn">
              <Smartphone className="w-4 h-4" /> Add to home screen
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
